import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './CheckoutPage.css';
import BankTransferInfoModal from './BankTransferInfoModal'; // Import the new modal

const CheckoutPage = ({ onWompiPayment, onBankTransfer }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [boat, setBoat] = useState(null);
  const [promotionDetails, setPromotionDetails] = useState(null);
  const [selectedOptionDetails, setSelectedOptionDetails] = useState(null);
  const [selectedPromotionDate, setSelectedPromotionDate] = useState('');
  const [quantity, setQuantity] = useState(1);
  const [customerName, setCustomerName] = useState('');
  const [customerEmail, setCustomerEmail] = useState('');
  const [customerPhone, setCustomerPhone] = useState('');
  const [termsAccepted, setTermsAccepted] = useState(false); // New state for terms

  const [isBankTransferInfoModalOpen, setIsBankTransferInfoModalOpen] = useState(false); // New state for modal
  const [currentBookingDetails, setCurrentBookingDetails] = useState(null); // To pass to modal

  const termsAndConditionsText = `Al completar esta compra, usted (en adelante "el Participante") reconoce y acepta los siguientes términos y condiciones establecidos por "Yo Amo Bazurto":

1. Consumo de Alcohol y Responsabilidad Individual: El Participante reconoce que esta experiencia puede incluir el consumo de bebidas alcohólicas. El consumo es voluntario y bajo la total responsabilidad del Participante. El Participante se compromete a consumir de manera moderada y responsable.

2. Exoneración de Responsabilidad por Accidentes: "Yo Amo Bazurto" no se hace responsable por ningún tipo de accidente, lesión, percance o condición médica que el Participante pueda sufrir antes, durante o después de la experiencia, derivados de su propio comportamiento, del de terceros, o por el consumo de alcohol.

3. Objetos Personales: El Participante es el único responsable de sus objetos personales (tales como teléfonos, cámaras, bolsos, documentos, etc.). "Yo Amo Bazurto" no se responsabiliza por la pérdida, robo o daño de ninguna pertenencia personal.

4. Aceptación de Riesgos: El Participante entiende y acepta voluntariamente los riesgos asociados a la participación en esta experiencia, incluyendo aquellos relacionados con el entorno y el consumo de alcohol.

La finalización de la compra constituye la aceptación expresa e irrevocable de todos los términos y condiciones aquí descritos.`;

  useEffect(() => {
    const storedPromotion = localStorage.getItem('selectedPromotionForCheckout');
    const storedOption = localStorage.getItem('selectedPromotionOptionForCheckout');
    const storedDate = localStorage.getItem('selectedPromotionDateForCheckout');
    const storedBoat = localStorage.getItem('selectedBoatForCheckout');

    if (storedPromotion && storedOption) {
      setPromotionDetails(JSON.parse(storedPromotion));
      setSelectedOptionDetails(JSON.parse(storedOption));
      setSelectedPromotionDate(storedDate);
    } else if (storedBoat) {
      setBoat(JSON.parse(storedBoat));
    } else {
      navigate('/promotions'); 
    }
  }, [navigate]);

  const itemToBook = promotionDetails ? selectedOptionDetails : boat;
  const maxCapacity = itemToBook ? (itemToBook.stock || itemToBook.capacidad || 1) : 1;
  const unitPrice = itemToBook ? (itemToBook.price || itemToBook.precio || 0) : 0;
  const totalPrice = unitPrice * quantity;

  const handleQuantityChange = (newQuantity) => {
    if (newQuantity >= 1 && newQuantity <= maxCapacity) {
      setQuantity(newQuantity);
    }
  };

  const handleDecrement = () => {
    handleQuantityChange(quantity - 1);
  };

  const handleIncrement = () => {
    handleQuantityChange(quantity + 1);
  };

  const handlePayment = (paymentMethod) => {
    const customerData = {
      fullName: customerName,
      email: customerEmail,
      phoneNumber: customerPhone,
    };

    if (!customerName || !customerEmail || !customerPhone) {
      alert('Por favor, completa todos los datos del cliente.');
      return;
    }

    if (!termsAccepted) {
      alert('Debes aceptar los términos y condiciones para continuar.');
      return;
    }

    if (paymentMethod === 'wompi') {
      if (promotionDetails) {
        onWompiPayment(customerData, promotionDetails, selectedOptionDetails, selectedPromotionDate, quantity);
      } else {
        onWompiPayment(boat, quantity, customerData);
      }
    } else if (paymentMethod === 'transferencia') {
      // Construct booking details to pass to onBankTransfer and the modal
      const bookingDetails = {
        clienteNombre: customerName,
        clienteEmail: customerEmail,
        clienteTelefono: customerPhone,
        tipoEntrada: promotionDetails ? selectedOptionDetails.name : boat.nombre, 
        cantidad: quantity,
        precioUnitario: unitPrice,
        precioTotal: totalPrice,
        metodoPago: paymentMethod,
        estadoPago: 'pendiente',
        fechaReserva: new Date().toISOString(),
        selectedPromotionDate: selectedPromotionDate, // Add selectedPromotionDate here
      };

      // Call onBankTransfer to save to Firestore
      if (promotionDetails) {
        console.log("Debug: selectedOptionDetails before onBankTransfer", selectedOptionDetails);
        onBankTransfer(customerData, promotionDetails, selectedOptionDetails, selectedPromotionDate, quantity);
      } else {
        onBankTransfer(boat, quantity, customerData, paymentMethod);
      }
      
      // Set details and open the modal
      setCurrentBookingDetails(bookingDetails);
      setIsBankTransferInfoModalOpen(true);
    }
  };

  if (!itemToBook) {
    return <div className="checkout-page-container">Cargando detalles del pedido...</div>;
  }

  return (
    <div className="checkout-page-container">
      <button onClick={() => navigate(-1)} className="back-button">← Volver</button>
      {/* <h2>Checkout para {boat.nombre}</h2> */}

      <div className="checkout-content-grid">
        <div className="checkout-left-column">
          <div className="customer-data-form-section">
            <h3>Datos del Cliente</h3>
            <input
              type="text"
              placeholder="Nombre Completo"
              value={customerName}
              onChange={(e) => setCustomerName(e.target.value)}
            />
            <input
              type="email"
              placeholder="Correo Electrónico"
              value={customerEmail}
              onChange={(e) => setCustomerEmail(e.target.value)}
            />
            <input
              type="tel"
              placeholder="Número de Teléfono"
              value={customerPhone}
              onChange={(e) => setCustomerPhone(e.target.value)}
            />
          </div>

          <div className="terms-and-conditions-section">
            <h3>Términos y Condiciones</h3>
            <div className="terms-text-box">
              {termsAndConditionsText}
            </div>
            <div className="terms-checkbox-container">
              <input 
                type="checkbox" 
                id="terms" 
                checked={termsAccepted} 
                onChange={e => setTermsAccepted(e.target.checked)}
              />
              <label htmlFor="terms">He leído y acepto los términos y condiciones.</label>
            </div>
          </div>
        </div>

        <div className="checkout-right-column">
          <div className="checkout-details-section">
            <p><strong>Precio por cupo:</strong> ${unitPrice.toLocaleString('es-CO')} COP</p>
            <p><strong>Capacidad máxima:</strong> {maxCapacity} personas</p>

            <div className="quantity-selector">
              <label htmlFor="quantity">Cantidad de cupos:</label>
              <div className="quantity-input-group">
                <button onClick={handleDecrement} disabled={quantity <= 1}>-</button>
                <span>{quantity}</span>
                <button onClick={handleIncrement} disabled={quantity >= maxCapacity}>+</button>
              </div>
            </div>

            <h3>Resumen del Pedido</h3>
            {promotionDetails ? (
                <>
                    <p>Promoción: {promotionDetails.title}</p>
                    <p>Opción: {selectedOptionDetails.name}</p>
                    {selectedPromotionDate && <p>Fecha: {selectedPromotionDate}</p>}
                </>
            ) : (
                <p>Bote: {boat.nombre}</p>
            )}
            <p>Cupos: {quantity}</p>
            <p><strong>Total a pagar:</strong> ${totalPrice.toLocaleString('es-CO')} COP</p>
          </div>

          <div className="payment-options-section">
            <h3>Selecciona tu método de pago</h3>
            <button 
              className="payment-button wompi"
              onClick={() => handlePayment('wompi')}
            >
              Paga con Tarjeta o PSE
            </button>
            <button 
              className="payment-button bank-transfer"
              onClick={() => handlePayment('transferencia')}
            >
              Transferencia Bancaria
            </button>
          </div>
        </div>
      </div>

      {isBankTransferInfoModalOpen && currentBookingDetails && (
        <BankTransferInfoModal
          bookingDetails={currentBookingDetails}
          onClose={() => {
            setIsBankTransferInfoModalOpen(false);
            navigate('/promotions'); // Redirect after closing modal
          }}
        />
      )}
    </div>
  );
};

export default CheckoutPage;
